"use strict";
const l = typeof Blob < "u" ? Blob : null;
export {
  l as default
};
//# sourceMappingURL=index.es409.js.map
